export class CreateMenuRequest {
  public descripcion?: string
  public icon?: string
  public path?: string
  public idMenuPadre?: number
  public nivel?: number
  public orden?: number
}
